import { Entry } from '@services/core-services/models';

export const sortEntries = (firstArray: Entry[], secondArray: Entry[]): Entry[] => {
  const idIndexMap = new Map(secondArray.map((image, index) => [image.id, index]));

  return firstArray.sort((a, b) => (idIndexMap.get(a.id) || 0) - (idIndexMap.get(b.id) || 0));
};
